'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {

	return {
		checkIfSourcingWaiverIsNecessary:
			$resource(
				apiConfig.$get().apiUrl + '/sourcingwaiver/check?basketId=:basketId',
				{
					basketId: '@basketId',
				},
				{
					query: {
						isArray: false
					}
				}
			),
		sendSourcingWaiver:
			$resource(
				apiConfig.$get().apiUrl + '/sourcingwaiver/explanation?basketId=:basketId&comment=:comment&customerId=:customerId',
				{
					basketId: '@basketId',
					comment: '@comment',
					customerId: '@customerId'
				},
				{
					create: {
						method: 'POST'
					},
				}
			),
		updateOrderIdForSourcingWaiver:
			$resource(
				apiConfig.$get().apiUrl + '/sourcingwaiver/explanation/:basketId',
				{
					basketId: '@basketId',
				},
				{
					update: {
						method: 'PUT',
						data: '@orderId'
					},
				}
			),
		getExplanationForBasket:
			$resource(
				apiConfig.$get().apiUrl + '/sourcingwaiver/explanation/basket/:basketId',
				{
					basketId: '@basketId'
				},
				{
					query: {
						isArray: true,
					}
				}
			),
	};

}
